import { RefObject, Ref, RefCallback } from 'react';

export function useMergeRefs<T>(
  ...refs: (Ref<T> | null | undefined)[]
): RefCallback<T> {
  return (value: T) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null && 'current' in ref) {
        (ref as RefObject<T>).current = value;
      }
    });
  };
}
